module.exports = __webpack_public_path__ + "static/media/logo-sidebar.3cb808af.svg";